import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { GridRowParams, GridToolbar } from '@mui/x-data-grid-pro';
import { DataTable } from '@pihealth/common-ui-library';
import React, { useEffect, useState } from 'react';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { useGetAssignedFormsMutation } from 'src/services/subjectToolkit';
import { useCompleteToolkitFormDataMutation } from 'src/services/toolkitForms';
import { setMessage } from 'src/store/Message';
import {
  setAssignedFormsPatientTrail,
  setFormLibraryDataIsOpen,
  setFormLibraryMainData
} from 'src/store/SelectedIntrialPatient';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { PopupComponent } from '../../../components/common/PopupComponent';
import staticData from '../../../resources/static.json';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
const Assignments: React.FC<any> = ({ parent_id, prescreen_id, actionConfiguredFormsSteps }) => {
  // for Datagrdi static columns
  const assignedColoumns = staticData.AssignedForms.colomn;
  const { checkPermission } = usePermissionWrapper();
  const dispatch = useAppDispatch();
  const [assignedRows, setAssignedRows] = React.useState<any[]>([]);
  const [pageSize, setPageSize] = useState(10);
  const [rowsCount, setRowsCount] = useState<any>(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [filterObject, setFilterObject] = useState<any>();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { preferences } = useUser();
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const [
    getAssignedForms,
    { data: getAssignedFormsData, isLoading: getAssignedFormsLoading, isError: getAssignedFormsIsError }
  ] = useGetAssignedFormsMutation();

  const getAssignedFormsDetails = (from: number, size: number) => {
    getAssignedForms({
      from,
      size,
      parent_id,
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      data: filterObject
    });
  };
  useEffect(() => {
    if (!getAssignedFormsLoading && (pageSize === 10 || pageSize === 20 || pageSize === 30)) {
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getAssignedFormsDetails(0, pageSize);
      } else {
        getAssignedFormsDetails(pageNumber * pageSize, pageSize);
      }
    }
  }, [parent_id, prescreen_id, actionConfiguredFormsSteps, pageNumber, pageSize, filterObject]);

  useEffect(() => {
    if (getAssignedFormsData) {
      setRowsCount(getAssignedFormsData.records_count);
      const newClonedData = JSON.parse(JSON.stringify(getAssignedFormsData.assigned_forms));
      newClonedData.sort((a: any, b: any) => {
        return a.display_order - b.display_order;
      });

      if (newClonedData && newClonedData.length > 0) {
        for (let i = 0; i < newClonedData.length; i++) {
          if (checkPermission('complete_toolkit_forms')) {
            if (newClonedData[i].generate_subject_id || newClonedData[i].activate_crf || newClonedData[i].enrollment) {
              newClonedData[i] = { ...newClonedData[i], completed_isDisabled: true, isAssignmentTab: true };
            } else {
              newClonedData[i] = { ...newClonedData[i], completed_isDisabled: false, isAssignmentTab: true };
            }
          } else {
            newClonedData[i] = { ...newClonedData[i], completed_isDisabled: true, isAssignmentTab: true };
          }
        }
      }

      setAssignedRows(newClonedData);
      dispatch(setAssignedFormsPatientTrail(getAssignedFormsData.assigned_forms));
    }

    if (getAssignedFormsIsError) {
      setAssignedRows([]);
      setRowsCount(0);
    }
  }, [getAssignedFormsData, getAssignedFormsIsError]);

  useEffect(() => {
    dispatch(setAssignedFormsPatientTrail(assignedRows as any));
  }, []);

  const gotoPage = (data: any) => {
    dispatch(setFormLibraryMainData(data));
    dispatch(setFormLibraryDataIsOpen(true));
  };

  const [openCompleteForm, setopenCompleteForm] = useState(false);

  const [seletedCompleteForm, setseletedCompleteForm] = useState<any>(null);

  const checkCompletionOrderAndOpenCompletionForm = (selectedForm: any) => {
    setseletedCompleteForm(selectedForm);
    if (!selectedForm.generate_subject_id && !selectedForm.activate_crf && !selectedForm.enrollment) {
      if (
        !selectedForm?.e_sign_form ||
        (selectedForm?.e_sign_form && selectedForm.signed_by != null && selectedForm.signed_on != null)
      ) {
        setopenCompleteForm(true);
      } else if (selectedForm?.e_sign_form && selectedForm.signed_by == null && selectedForm.signed_on == null) {
        dispatch(
          setMessage({
            msgDetails: 'Signature is pending',
            severity: 'error'
          })
        );
      }
    }
  };

  const [
    completeToolkitForm,
    {
      isError: completeToolkitFormIsError,
      error: completeToolkitFormError,
      isSuccess: completeToolkitFormSuccess,
      isLoading: completeToolkitFormLoading
    }
  ] = useCompleteToolkitFormDataMutation();

  useEffect(() => {
    if (!completeToolkitFormLoading && completeToolkitFormIsError) {
      const errorData: any = completeToolkitFormError;
      if (errorData?.status == 500 || errorData?.status == 502 || errorData?.status == 503) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Forbbiden Access`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: errorData?.data?.context.message,
            severity: 'error'
          })
        );
      }
    } else if (!completeToolkitFormLoading && completeToolkitFormSuccess) {
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getAssignedFormsDetails(0, pageSize);
      } else {
        getAssignedFormsDetails(pageNumber * pageSize, pageSize);
      }
      dispatch(
        setMessage({
          msgDetails: 'Form completed successfully',
          severity: 'success'
        })
      );
    }
  }, [completeToolkitFormLoading, completeToolkitFormSuccess, completeToolkitFormIsError, completeToolkitFormIsError]);

  const handleCloseCompleteForm = () => {
    setopenCompleteForm(false);
  };

  const handleConfirmCompleteForm = () => {
    setopenCompleteForm(false);
    if (seletedCompleteForm) {
      completeToolkitForm({
        data: { toolkit_form_id: seletedCompleteForm?.id },
        parent_id,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry
      });
    }
  };
  const filterValues = (data: any) => {
    setFilterObject(data);
  };

  const actions = {
    name: (data: any) => {
      gotoPage(data);
    },
    completed: (data: any) => {
      checkCompletionOrderAndOpenCompletionForm(data);
    }
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `${`Assignments`} ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  return (
    <div>
      <div style={{ minHeight: '50vh', width: '100%' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          <div style={{ flexGrow: 1 }}>
            <DataTable
              columns={assignedColoumns}
              rows={assignedRows}
              components={{
                Toolbar: GridToolbar
              }}
              loading={getAssignedFormsLoading}
              pagination
              disableSelectionOnClick
              className="TSDADatagrid"
              isRowSelectable={(params: GridRowParams) => !params.row.is_mandatory}
              actions={actions}
              datePreference={preferences?.date_format ? preferences?.date_format : 'MM/dd/yyyy'}
              showDateAndTime={false}
              paging
              pageSize={pageSize}
              setPageSize={setPageSize}
              rowsCount={rowsCount}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              paginationMode="server"
              hasDefinedDataGridToolbarExport
              definedGridToolbarExport={definedCustomDatGridExport}
              filterValues={(data: any) => filterValues(data)}
              dataTableProps={{ filterMode: 'server' }}
            />
          </div>
        </div>
      </div>
      <PopupComponent open={openCompleteForm}>
        <DialogTitle />
        <DialogContent>
          Are you sure to mark it as completed? You will not be allowed to undo the completion later
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCompleteForm} className="grey-btn">
            No
          </Button>
          <Button onClick={handleConfirmCompleteForm}>Yes</Button>
        </DialogActions>
      </PopupComponent>
    </div>
  );
};

export default Assignments;
